import type { OrgMembership } from '@finvox/shared/org';

/** Pick the first org id the user can access (membership list or live member doc lookup). */
export async function pickAccessibleOrgId(
  preferredIds: Array<string | undefined | null>,
  memberships: OrgMembership[],
  verifyMembership: (orgId: string) => Promise<boolean>
): Promise<string | undefined> {
  const seen = new Set<string>();

  for (const candidate of preferredIds) {
    const orgId = candidate?.trim();
    if (!orgId || seen.has(orgId)) continue;
    seen.add(orgId);

    if (memberships.some((m) => m.orgId === orgId)) return orgId;
    if (await verifyMembership(orgId)) return orgId;
  }

  return undefined;
}
